import { render, staticRenderFns } from "./PlatformSelector.vue?vue&type=template&id=21cf4ee9"
import script from "./PlatformSelector.vue?vue&type=script&lang=js"
export * from "./PlatformSelector.vue?vue&type=script&lang=js"
import style0 from "./PlatformSelector.vue?vue&type=style&index=0&id=21cf4ee9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports